import * as React from 'react'
import { Form, Field, InjectedFormProps } from 'redux-form'
import { Input } from 'components/Input/Input'
import SelectPretty from 'components/Input/SelectPretty'
import Button from 'components/Button'
import cn from 'classnames'
import * as sMarg from 'styles/modules/margins.scss'
import { Row, Col } from 'components/Layout'
import * as sLay from 'styles/modules/layout.scss'
import {
  IHuntGroupFormData,
  IPhoneSystemHuntGroupEditFormProps,
} from './PhoneSystemHuntGroupEditForm.container'
import {
  GetPhoneSystemServiceDocument,
  useCreatePhoneSystemHuntGroupMutation,
  useUpdatePhoneSystemHuntGroupMutation,
} from 'src/generated/graphql'
import { ExtensionsSelect } from './ExtensionsSelect'
import { vNotEmpty } from 'components/Input/Input.validations'

export type IPhoneSystemHuntGroupEditFormComponentProps = IPhoneSystemHuntGroupEditFormProps &
  InjectedFormProps<IHuntGroupFormData>

const vNumber = value => {
  if (value && value.length != 4) {
    return 'Number should be 4 digits long'
  }

  if (value && !/^\d+$/.test(value)) {
    return 'Only digits allowed'
  }

  return undefined
}

export const PhoneSystemHuntGroupEditFormComponent = (
  props: IPhoneSystemHuntGroupEditFormComponentProps
) => {
  const { submitting, handleSubmit, onAfterSubmit, isAdmin } = props
  const [updatePhoneSystemHuntGroup] = useUpdatePhoneSystemHuntGroupMutation()
  const [createPhoneSystemHuntGroup] = useCreatePhoneSystemHuntGroupMutation()

  const huntSequenceOptions = [
    {
      name: 'Order',
      value: 'Order',
    },
    {
      name: 'Random',
      value: 'Random',
    },
    {
      name: 'Simultaneous',
      value: 'Simultaneous',
    },
    {
      name: 'Least Used',
      value: 'LeastUsed',
    },
  ]

  return (
    <Form
      onSubmit={handleSubmit(async variables => {
        if (variables.huntGroupId) {
          await updatePhoneSystemHuntGroup({ variables })
        } else {
          await createPhoneSystemHuntGroup({
            variables,
            refetchQueries: [
              {
                query: GetPhoneSystemServiceDocument,
                variables: { id: props.initialValues.phoneSystemId },
              },
            ],
            awaitRefetchQueries: true,
          })
        }
        onAfterSubmit()
      })}
    >
      <Row className={cn(sLay['layout-row'], 'sm')}>
        <Col className={cn(sLay['flex-50'], 'sm')}>
          <Field name="name" label="Name" component={Input} validate={vNotEmpty} />
        </Col>
        <Col className={cn(sLay['flex-50'], 'sm')}>
          <Field
            name="number"
            label="Number"
            component={Input}
            disabled={!(!props.initialValues.huntGroupId || isAdmin)}
            validate={[vNotEmpty, vNumber]}
          />
        </Col>
      </Row>
      <Field
        name="huntSequence"
        label="Hunt Sequence"
        component={SelectPretty}
        options={huntSequenceOptions}
      />
      <Field
        name="extensionIds"
        label="Company"
        component={ExtensionsSelect}
        phoneSystemId={props.initialValues.phoneSystemId}
      />
      <div className={cn(sLay['layout-column'], sLay['layout-align-center-center'], sMarg.mt30)}>
        <Button color="tertiary" loading={submitting} disabled={submitting} type="submit">
          {!!props.initialValues.huntGroupId ? 'Update' : 'Create'}
        </Button>
      </div>
    </Form>
  )
}



// WEBPACK FOOTER //
// src/features/PhoneSystem/PhoneSystemHuntGroupEditForm/PhoneSystemHuntGroupEditForm.tsx